import * as React from "react";
import {useEffect, useState} from "react";
import {checkAccess} from "../api";
import {Button, CircularProgress, createStyles, makeStyles, Theme} from '@material-ui/core';
import {ThemeProvider} from '@material-ui/core/styles'
import {eosTheme} from "../style/theme";
import {authenticationParameters, authProvider} from "../utils/authProvider";

export const AdminPortal: React.FC = ({children}) => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null)

  useEffect(() => {

    console.log("env base url: " + process.env.REACT_APP_BASE_URL)
    console.log("client id: " + process.env.REACT_APP_CLIENT_ID)
    updateAccess()

    // setup interval for the token update
    const updateToken = () => {
      authProvider.getIdToken(authenticationParameters).then(() => {
        console.log("token updated")
        updateAccess()
      });
    }

    const interval = setInterval(() => {
      updateToken()
    }, 3300000);

    return () => {
      clearInterval(interval);
    };
  }, [])

  const updateAccess = () => {
    checkAccess().then(res => {
      setIsAdmin(res)
    })
  }

  return (
    <ThemeProvider theme={eosTheme}>
      {isAdmin ? children : (isAdmin === null ? <Loading/> : <NotAdmin/>)}
    </ThemeProvider>
  )
}

const Loading: React.FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.fullScreen}>
      <CircularProgress/>
    </div>
  )
}

const NotAdmin: React.FC = () => {
  const classes = useStyles()
  return (
    <div className={classes.fullScreen}>
      You don't have access to this page
      <Button className={classes.button} variant="contained" color="secondary" onClick={() => document.location.reload()}>
        Refresh the page
      </Button>
    </div>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fullScreen: {
      display: 'flex',
      flexDirection: 'column',
      width: "100vw",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center"
    },
    button: {
      margin: theme.spacing(3)
    }
  }),
)